var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1519_17476)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9991 15.9999C14.7941 15.9999 13.8173 16.9767 13.8173 18.1817C13.8173 19.3867 14.7941 20.3635 15.9991 20.3635C17.2041 20.3635 18.1809 19.3867 18.1809 18.1817C18.1809 16.9767 17.2041 15.9999 15.9991 15.9999ZM15.2718 18.1817C15.2718 17.7801 15.5974 17.4545 15.9991 17.4545C16.4008 17.4545 16.7264 17.7801 16.7264 18.1817C16.7264 18.5834 16.4008 18.909 15.9991 18.909C15.5974 18.909 15.2718 18.5834 15.2718 18.1817Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.09 13.0908C11.885 13.0908 10.9082 14.0677 10.9082 15.2726V23.9999C10.9082 25.2049 11.885 26.1817 13.09 26.1817H26.1809C27.3859 26.1817 28.3627 25.2049 28.3627 23.9999V15.2726C28.3627 14.0677 27.3859 13.0908 26.1809 13.0908H13.09ZM26.1809 14.5454H13.09C12.6884 14.5454 12.3627 14.871 12.3627 15.2726V23.9999C12.3627 24.4016 12.6884 24.7272 13.09 24.7272H16.2273L21.2299 19.7245C22.082 18.8725 23.4634 18.8725 24.3155 19.7245L26.9082 22.3172V15.2726C26.9082 14.871 26.5826 14.5454 26.1809 14.5454ZM26.1809 24.7272H18.2843L22.2585 20.7531C22.5425 20.469 23.003 20.469 23.287 20.7531L26.8406 24.3066C26.7249 24.555 26.473 24.7272 26.1809 24.7272Z",
    fill: "#D1D1D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1519_17476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4545,
    height: 17.4545,
    fill: "white",
    transform: "translate(10.9082 10.9092)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDefault);
export default __webpack_public_path__ + "static/media/icon-default.54ee47fb769cd40f7ab04afef855f3ea.svg";
export { ForwardRef as ReactComponent };